import React, { useEffect } from 'react'
import { useTranslation } from 'i18n'
import { sendMessageToApp } from 'utils/react-native-webview'
import { useForceUpdateGate } from './ForceUpdateGate.hooks'

export const ForceUpdateGate = () => {
  const { t } = useTranslation()
  const { isBlocked, storeUrl, storeDeepLink, canOpenExternal } =
    useForceUpdateGate()

  const openStore = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!canOpenExternal) return
    event.preventDefault()
    sendMessageToApp({ type: 'open_external', data: { url: storeDeepLink } })
  }

  useEffect(() => {
    if (!isBlocked) return

    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'

    return () => {
      document.body.style.overflow = previousOverflow
    }
  }, [isBlocked])

  if (!isBlocked) {
    return null
  }

  return (
    <div
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="force-update-title"
      data-testid="force-update-gate"
      className="fixed inset-0 z-[10000] flex flex-col items-center justify-center gap-4 bg-white px-6 text-center"
    >
      <h1
        id="force-update-title"
        className="text-2xl font-bold leading-tight text-gray-900"
      >
        {t('Hora de atualizar')}
      </h1>
      <p className="max-w-[36ch] text-base leading-normal text-gray-700">
        {t('Toque no botão para baixar a versão mais nova do aplicativo.')}
      </p>
      <a
        href={storeUrl}
        onClick={openStore}
        data-testid="force-update-gate-action"
        className="mt-4 w-full max-w-[320px] rounded-large bg-primary-500 px-4 py-4 text-base font-bold text-gray-900"
      >
        {t('Atualizar')}
      </a>
    </div>
  )
}

export default ForceUpdateGate
